module.exports = __webpack_public_path__ + "static/media/mx.6ee1e6d4.svg";